import { render, staticRenderFns } from "./IndentView.vue?vue&type=template&id=ff6dad30&scoped=true"
import script from "./IndentView.vue?vue&type=script&lang=js"
export * from "./IndentView.vue?vue&type=script&lang=js"
import style0 from "./IndentView.vue?vue&type=style&index=0&id=ff6dad30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6dad30",
  null
  
)

export default component.exports